import { render, staticRenderFns } from "./wallet-setting.vue?vue&type=template&id=68188c96&scoped=true"
import script from "./wallet-setting.vue?vue&type=script&lang=js"
export * from "./wallet-setting.vue?vue&type=script&lang=js"
import style0 from "./wallet-setting.vue?vue&type=style&index=0&id=68188c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68188c96",
  null
  
)

export default component.exports